module.exports = __webpack_public_path__ + "img/youness.a6ff0337.png";